import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import qs from 'qs';
import { debounce } from 'lodash';

import { parseQueryParams } from 'utils/url';

import { DEALER_QUERY_STRING_PARAM, DEALER_SEARCH_VALUE } from './constants';
import { Consumer } from './DealerSearchContext';

class DebouncedQueryStringUpdater extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    debounceMS: PropTypes.number,
    searchValue: PropTypes.string.isRequired,
  };

  static defaultProps = {
    debounceMS: 300,
  };

  componentDidUpdate(prevProps) {
    if (this.props.searchValue !== prevProps.searchValue) {
      this.startTransition();
    }
  }

  startTransition = () => {
    this.debounceTransition();
  };

  debounceTransition = debounce(
    () => this.doTransition(),
    this.props.debounceMS,
  );

  doTransition = () => {
    const { searchValue, history, location } = this.props;

    const oldQueryString = location.search;
    const queryParams = parseQueryParams(oldQueryString);

    const newQueryString = qs.stringify(
      { ...queryParams, [DEALER_QUERY_STRING_PARAM]: searchValue },
      { skipNulls: true },
    );

    history.replace({ search: newQueryString });
  };

  render() {
    return this.props.children;
  }
}

DebouncedQueryStringUpdater.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

/**
 * Listens for changes to the `dealerSearchValue` in the dealer search
 * context and pushes a modification to the URL query string to reflect
 * the latest search input. This modification is debounced to prevent
 * constant updates on each keypress.
 * @param WrappedComponent
 * @return {function(*=): *}
 */
export default function withSearchParamUpdater(WrappedComponent) {
  return componentProps => (
    <Consumer>
      {({ [DEALER_SEARCH_VALUE]: dealerSearchValue }) => (
        <Route
          render={props => (
            <DebouncedQueryStringUpdater
              {...props}
              searchValue={dealerSearchValue}
            >
              <WrappedComponent {...componentProps} />
            </DebouncedQueryStringUpdater>
          )}
        />
      )}
    </Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerSearch/withSearchParamUpdater.js